import { getAuth } from './auth';

export async function requireAuth(to) {
  const auth = getAuth();
  await auth.init();

  if (auth.isAuthenticated.value) {
    return true;
  }

  await auth.login({
    redirectPath: to.fullPath || '/chat',
  });

  return false;
}
